import axios from 'axios';

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
export const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : configuredBackendUrl;
export const API = `${BACKEND_URL}/api`;
export const backendUrl = (path) => `${BACKEND_URL}${path}`;

// Public APIs
export const getSettings = () => axios.get(`${API}/settings`);
export const getAbout = () => axios.get(`${API}/about`);
export const getSliders = () => axios.get(`${API}/sliders`);
export const getCompanies = () => axios.get(`${API}/companies`);
export const getCompany = (slug) => axios.get(`${API}/companies/${slug}`);
export const getProjects = () => axios.get(`${API}/projects`);
export const getProject = (slug) => axios.get(`${API}/projects/${slug}`);
export const getEhiaaInitiative = () => axios.get(`${API}/ehiaa-initiative`);
export const getApplications = () => axios.get(`${API}/applications`);
export const getNews = () => axios.get(`${API}/news`);
export const getNewsItem = (slug) => axios.get(`${API}/news/${slug}`);
export const getBoardSection = () => axios.get(`${API}/board-section`);
export const getBoardMembers = () => axios.get(`${API}/board-members`);
export const getJobs = () => axios.get(`${API}/jobs`);
export const getJob = (id) => axios.get(`${API}/jobs/${id}`);
export const createContact = (data) => axios.post(`${API}/contacts`, data);
export const submitJobApplication = (data) => axios.post(`${API}/job-applications`, data);

// Admin APIs - Settings & About
export const updateSettings = (data) => axios.put(`${API}/settings`, data);
export const updateAbout = (data) => axios.put(`${API}/about`, data);
export const updateEhiaaInitiative = (data) => axios.put(`${API}/ehiaa-initiative`, data);

// Admin APIs - Sliders
export const createSlider = (data) => axios.post(`${API}/sliders`, data);
export const updateSlider = (id, data) => axios.put(`${API}/sliders/${id}`, data);
export const deleteSlider = (id) => axios.delete(`${API}/sliders/${id}`);

// Admin APIs - Companies
export const createCompany = (data) => axios.post(`${API}/companies`, data);
export const updateCompany = (id, data) => axios.put(`${API}/companies/${id}`, data);
export const deleteCompany = (id) => axios.delete(`${API}/companies/${id}`);

// Admin APIs - Projects
export const createProject = (data) => axios.post(`${API}/projects`, data);
export const updateProject = (id, data) => axios.put(`${API}/projects/${id}`, data);
export const deleteProject = (id) => axios.delete(`${API}/projects/${id}`);

// Admin APIs - Applications
export const createApplication = (data) => axios.post(`${API}/applications`, data);
export const updateApplication = (id, data) => axios.put(`${API}/applications/${id}`, data);
export const deleteApplication = (id) => axios.delete(`${API}/applications/${id}`);

// Admin APIs - News
export const createNews = (data) => axios.post(`${API}/news`, data);
export const updateNews = (id, data) => axios.put(`${API}/news/${id}`, data);
export const deleteNews = (id) => axios.delete(`${API}/news/${id}`);

// Admin APIs - Board
export const updateBoardSection = (data) => axios.put(`${API}/board-section`, data);
export const createBoardMember = (data) => axios.post(`${API}/board-members`, data);
export const updateBoardMember = (id, data) => axios.put(`${API}/board-members/${id}`, data);
export const deleteBoardMember = (id) => axios.delete(`${API}/board-members/${id}`);

// Admin APIs - Jobs
export const createJob = (data) => axios.post(`${API}/jobs`, data);
export const updateJob = (id, data) => axios.put(`${API}/jobs/${id}`, data);
export const deleteJob = (id) => axios.delete(`${API}/jobs/${id}`);

// Admin APIs - Job Applications
export const getJobApplications = () => axios.get(`${API}/job-applications`);
export const getApplicationsForJob = (jobId) => axios.get(`${API}/job-applications/${jobId}/applications`);
export const updateApplicationStatus = (id, status) => axios.put(`${API}/job-applications/${id}/status`, { status });
export const deleteJobApplication = (id) => axios.delete(`${API}/job-applications/${id}`);

// Admin APIs - Contacts
export const getContacts = () => axios.get(`${API}/contacts`);
export const markContactRead = (id) => axios.put(`${API}/contacts/${id}/read`);
export const deleteContact = (id) => axios.delete(`${API}/contacts/${id}`);

// Admin APIs - Admin Users Management
export const getAdmins = () => axios.get(`${API}/admins`);
export const createAdmin = (data) => axios.post(`${API}/admins`, data);
export const updateAdmin = (id, data) => axios.put(`${API}/admins/${id}`, data);
export const deleteAdmin = (id) => axios.delete(`${API}/admins/${id}`);

// Image Upload - requires auth token
export const uploadImage = (file) => {
  const token = localStorage.getItem('raad-token');
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/upload`, formData, {
    headers: { 
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${token}`
    }
  });
};

export const uploadImageBase64 = (imageData, extension = 'png') => {
  const token = localStorage.getItem('raad-token');
  return axios.post(`${API}/upload-base64`, { image: imageData, extension }, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};
